/**
 * @generated SignedSource<<ea83c08ac551431ab4332e8388e2d25b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type GenerateContentRelatedQuestionsInput = {
  contentUsageId: string;
};
export type ContentSuggestedPromptsListMutation$variables = {
  input: GenerateContentRelatedQuestionsInput;
};
export type ContentSuggestedPromptsListMutation$data = {
  readonly generateContentRelatedQuestions: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly relatedQuestions: ReadonlyArray<{
      readonly id: string;
    }> | null;
  };
};
export type ContentSuggestedPromptsListMutation = {
  response: ContentSuggestedPromptsListMutation$data;
  variables: ContentSuggestedPromptsListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateContentRelatedQuestionsResponse",
    "kind": "LinkedField",
    "name": "generateContentRelatedQuestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BrainSearchRelatedQuestion",
        "kind": "LinkedField",
        "name": "relatedQuestions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentSuggestedPromptsListMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentSuggestedPromptsListMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "66783283cafd055be3c64dab05e2f7e9",
    "id": null,
    "metadata": {},
    "name": "ContentSuggestedPromptsListMutation",
    "operationKind": "mutation",
    "text": "mutation ContentSuggestedPromptsListMutation(\n  $input: GenerateContentRelatedQuestionsInput!\n) {\n  generateContentRelatedQuestions(input: $input) {\n    relatedQuestions {\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e3cd30971c664a1d324c04e3a51a2aa";

export default node;
